import { FormGroup } from '@angular/forms';
import { Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lns-form-field-error',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './form-field-error.component.html',
  styleUrls: ['./form-field-error.component.scss']
})
export class FormFieldErrorComponent {
  @Input() formGroup: FormGroup;
  @Input() translatePfx: string;
  @Input() field: string;
}
